export interface audioTheme {
  // interaction
  select?: string // click that selects component
  open?: string // click that opens new ui
  close?: string // click that closes existing ui
  cancel?: string // click that cancels current operations
  toggle?: string // click that changes a boolean value
  change?: string // click that confirms the change
  quickChange?: string // click that confirms a small change
  // data
  create?: string // confirmation that creates new data
  update?: string // confirmation on existing data
  delete?: string // confirmation on deleting data
  // feedback
  login?: string // feedback on login
  logout?: string // feedback on logout
  critical?: string // feedback on crash
  error?: string //feedback on error
}
const defaultTheme: audioTheme = {
  select: '/sounds/select.wav',
  open: '/sounds/open.wav',
  close: '/sounds/close.wav',
  cancel: '/sounds/cancel.wav',
  toggle: '/sounds/toggle.wav',
  change: '/sounds/change.wav',
  quickChange: '/sounds/quickChange.wav',
  create: '/sounds/create.wav',
  update: '/sounds/update.wav',
  delete: '/sounds/delete.wav',
  login: '/sounds/login.wav',
  logout: '/sounds/logout.wav',
  critical: '/sounds/critical.wav',
  error: '/sounds/error.wav',
}
export default defaultTheme
